const AllocationKeyModalStyles = {
  dialogContent: {
    mt: 2
  },
  
  autocompleteContainer: {
    mt: 2
  },
  filterIcon: (hasInput) => ({
    mr: 1,
    color: hasInput ? "primary" : "action"
  }),

  optionItem: (isNoKey) => ({
    borderBottom: isNoKey ? '1px solid rgba(0, 0, 0, 0.12)' : 'none',
    color: isNoKey ? 'rgba(0, 0, 0, 0.6)' : 'inherit',
    fontStyle: isNoKey ? 'italic' : 'normal'
  }),
  
  resultsText: {
    mt: 1
  },

  percentageModeSection: {
    my: 3
  },
  
  allocationAlert: {
    mb: 2,
    position: 'relative'
  },

  percentageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 0.5
  },

  progressBarContainer: {
    width: '100%',
    position: 'relative'
  },

  progressBarBackground: {
    width: '100%',
    height: 16,
    backgroundColor: 'rgba(0,0,0,0.08)',
    borderRadius: 3,
    position: 'relative'
  },

  progressBarFill: (percentage) => ({
    position: 'absolute',
    height: '100%',
    borderRadius: 3,
    backgroundColor: percentage === 100 
      ? 'success.main' 
      : percentage > 100 
        ? 'error.main' 
        : 'warning.main',
    width: `${Math.min(percentage, 100)}%`,
    transition: 'width 0.5s ease-in-out, background-color 0.3s ease'
  }),

  progressBarText: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'white',
    fontWeight: 'bold',
    textShadow: '0px 0px 2px rgba(0,0,0,0.7)',
    whiteSpace: 'nowrap'
  },

  allocationsContainer: {
    maxHeight: 400,
    overflowY: 'auto'
  },

  allocationPaper: {
    p: 2,
    mb: 2,
    backgroundColor: 'grey.50'
  },

  addAllocationButton: {
    mt: 1
  },

  submittingIndicator: {
    display: 'flex',
    justifyContent: 'center',
    my: 2
  },

  submitButton: {
    mr: 1
  }
};

export default AllocationKeyModalStyles;
